<template>
  <div :class="{ 'has-empty-state': !announcements.length }">
    <div v-if="announcements.length" id="al-announcement">
      <single-notification
        v-for="announcement in announcements.slice(0, limit)"
        :key="announcement._id"
        :notification="announcement"
        :icon-type="announcement.type.icon"
        @viewedNotification="viewAnnouncement(announcement._id)"
      />
    </div>
    <NotificationEmptyState v-else name="Announcement" />
  </div>
</template>

<script>
import SingleNotification from './SingleNotification.vue';
import NotificationEmptyState from './NotificationEmptyState.vue';

/**
 * Simple list of notifications with empty state when activities array is empty.
 * @displayName announcements-notification
 */

export default {
  components: {
    SingleNotification,
    NotificationEmptyState
  },
  props: {
    /**
     * Max number of notification to render.
     */
    limit: {
      type: Number,
      default: 10
    },
    /**
     * Array of javascript object with notification data. To know what structure is needed view [SingleNotification](/#/modules?id=singlenotification)
     */
    announcements: {
      type: Array,
      required: true
    }
  },
  methods: {
    viewAnnouncement(announcementId) {
      /**
       * Event emitting when user clicks in some internal notification.
       * @property {String} announcementId Id of announcement clicked
       */
      this.$emit('viewAnnouncement', announcementId);
      this.$router.push('/messages/index');
    }
  }
};
</script>
